import React, { Component } from 'react';
import IconForm from './IconForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Input extends Component {
	render() {
		return (
			<div className="control has-icons-left has-icons-right">
				<input className="input " id={this.props.htmlFor} name={this.props.name } type={this.props.type || 'text'} placeholder={this.props.placeholder || null} required={true } />
				<IconForm
        styleName={this.props.styleName}
        />
			</div>
		);
	}
}
export default Input;
